<div class="change-frequency-dialog">
  <div class="dialog-content p-4">
    <app-frequency-selector
      [frequency]="frequency"
      [frequencyType]="frequencyType"
      (selectFrequencyType)="selectFrequencyType($event)"
      (selectFrequency)="selectFrequency($event)"
    />
  </div>

  <div class="dialog-footer flex justify-end gap-2 p-4 border-t">
    <p-button
      label="Update"
      [disabled]="isUpdateDisabled()"
      (onClick)="update()"
      severity="primary"
    />
    <p-button
      label="Cancel"
      (onClick)="cancel()"
      severity="secondary"
      [outlined]="true"
    />
  </div>
</div>
